import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { sendChatMessage } from 'redux-store/thunk/chat.thunk'
import { MAX_MESSAGE_CHARACTERS_LIMIT } from 'utils/constants/index'
import { getAuthToken } from 'utils/common-services/cookie.service'

const ChatFooter = ({ bottomRef }) => {
  const dispatch = useDispatch()
  const userInfo = useSelector((state) => state.auth?.userInfo)
  const {
    selectedRoomId,
    selectedChatGroupId
  } = useSelector((state) => state.chat)
  const accessToken = !!getAuthToken()
  const [message, setMessage] = useState('')

  const handleSendMessage = (e) => {
    e.preventDefault()

    if (
      accessToken &&
      message.length <= MAX_MESSAGE_CHARACTERS_LIMIT &&
      message.length > 0 &&
      message.trim().length > 0
    ) {
      dispatch(
        sendChatMessage({
          message,
          userName: userInfo?.userName,
          languageId: selectedRoomId,
          groupId: selectedChatGroupId
        })
      )
      setMessage('')
      if (bottomRef?.current) {
        setTimeout(() => {
          const scrollContainer = bottomRef.current.closest('.chat-content-scroll')
          if (scrollContainer) {
            scrollContainer.scrollTo({
              top: scrollContainer.scrollHeight,
              behavior: 'smooth'
            })
          }
        }, 100)
      }
    }
  }

  const handleMessageChange = (e) => {
    const value = e.target.value
    if (value.length <= MAX_MESSAGE_CHARACTERS_LIMIT) {
      setMessage(value)
    }
  }

  return (
    <div className='chat-bottom-section'>
      <form onSubmit={handleSendMessage}>
        <div className='chat-typing'>
          <input
            type='text'
            className='chat-input'
            value={message}
            onChange={handleMessageChange}
            placeholder={accessToken ? 'Type your message...' : 'Please login to chat'}
            disabled={!accessToken}
          />
          <div className='chat-input-cta'>
            <button
              className='chat-send-btn'
              type='submit'
              disabled={
                !accessToken ||
                message.length > MAX_MESSAGE_CHARACTERS_LIMIT ||
                message.length <= 0 ||
                message.trim().length <= 0
              }
            >
              <svg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path d='M22 2L11 13' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
                <path d='M22 2L15 22L11 13L2 9L22 2Z' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
              </svg>
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default ChatFooter
